export default __webpack_public_path__ + "static/media/game-line-3.709998c4.png";